var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"filter",style:([_vm.filterStyle || {}])},[_vm._t("filter")],2),_c('div',{staticClass:"LaTable-body",style:([_vm.bodyStyle || {}])},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }